import React, { useState, useEffect, useContext, useCallback } from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter, Form, FormGroup, Label, Input, Button } from 'reactstrap';
import AsyncSelect from 'react-select/async';
import axios from 'axios';
import BetterStandsContext from "../../../Components/Contexts/Management/BetterStandsContext";
import {JAVA_BACKEND_API_URL} from "../../../Components/Contexts/BackendConstants";
import { useTranslation } from "react-i18next";

const UygunsuzlukModal = ({ isOpen, toggle, formId, standId, selectedData, categoryId, subId, konuName }) => {
  const { t } = useTranslation("saha");
    const [tehlikeOptions, setTehlikeOptions] = useState([]);
    const [selectedTehlike, setSelectedTehlike] = useState('');
    const [denetmenId, setDenetmenId] = useState("0");
    const [photo, setPhoto] = useState(null);
    const [photoPreview, setPhotoPreview] = useState(null);
    const { activeFairId, fetchActiveStands, getPostHeader } = useContext(BetterStandsContext);
    const [selectedStand, setSelectedStand] = useState(null);
    const [konuOptions, setKonuOptions] = useState([]);
    const [selectedKonu, setSelectedKonu] = useState('');
    const [selectedFaaliyet, setSelectedFaaliyet] = useState('');
    const [loading, setLoading] = useState(false);

    const fetchTehlikeOptions = useCallback(async () => {
        const requestID = selectedKonu ? selectedKonu : subId;
        if (requestID) {
            try {
                const response = await axios.get(`https://fds.sakagrup.com/FormSystem/get_form_tehlikes/${requestID}`);
                setTehlikeOptions(response.data);
            } catch (error) {
                console.error('Error fetching tehlike options:', error);
                setTehlikeOptions([]);
            }
        }
    }, [selectedKonu, subId]);

    useEffect(() => {
        const fetchKonuOptions = async () => {
            if (formId) {
                try {
                    const response = await axios.get(`https://fds.sakagrup.com/Saha/xGetAllKonus/${formId}`);
                    setKonuOptions(response.data);
                } catch (error) {
                    console.error('Error fetching konu options:', error);
                    setKonuOptions([]);
                }
            }
        };

        if (isOpen) {
            async function run() { await fetchTehlikeOptions(); await fetchKonuOptions(); }
            run();
        }
    }, [isOpen, subId, formId, fetchTehlikeOptions]);

    useEffect(() => {
        async function run() {
            const userId = localStorage.getItem('userId');
            if (userId) {
                setDenetmenId(userId);
            } else {
                console.error("User ID not found in localStorage");
            }
        }
        run();
    }, [isOpen]);

    useEffect(() => {
        if (denetmenId) {
            fetchActiveStands(0, 10, null, '');
        }
    }, [denetmenId, fetchActiveStands]);

    const loadStandOptions = async (inputValue) => {
        try {
            const page = 0;
            const limit = 10;
            const response = await axios.get(
                `${JAVA_BACKEND_API_URL}/betterStands/standsByFuarIdOpt2/${activeFairId}`,
                {
                    params: { page, limit, salonId: null, search: inputValue }, // search parametresini ekledik
                    headers: {
                        Authorization: getPostHeader.Authorization,
                        "X-token": getPostHeader.authToken,
                        "X-user-id": getPostHeader.userId,
                    },
                }
            );
            return response.data.fullStandInfoDTOS.content.map(stand => ({
                value: stand.standId,
                label: stand.standNumber+" ("+stand.companyName+") ",
            }));
        } catch (error) {
            console.error('Error fetching stand options:', error);
            return [];
        }
    };

    const handleStandChange = (selectedOption) => {
        setSelectedStand(selectedOption);
    };

    const handleKonuChange = (selectedOption) => {
        const sKonu = selectedOption.target.selectedOptions[0];
        setSelectedFaaliyet(sKonu.dataset.code);
        setSelectedKonu(sKonu.value);
    };

    const handleSubmitU = async (e) => {
        e.preventDefault();
        e.stopPropagation();
        setLoading(true);

        try {
            const formData = new FormData();
            formData.append('form_type_id', formId);
            formData.append('form_faaliyet_id', categoryId || selectedFaaliyet);
            formData.append('form_konu_id', selectedKonu || subId);
            formData.append('form_tehlike_id', selectedTehlike);
            formData.append('user_id', denetmenId);
            formData.append('fuar_id', activeFairId);
            formData.append('salon_id', selectedData?.hall || '');
            formData.append('stand_id', selectedStand ? selectedStand.value : standId);
            if (photo) {
                formData.append('photo', photo);
            }

            const response = await axios.post('https://fds.sakagrup.com/Saha/xSaveUyumsuzluk?stand_id=' + (selectedStand ? selectedStand.value : standId) + '&saha_form_id=0', formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            });

            console.log('Form submission successful:', response);
            setPhoto(null);
            setPhotoPreview(null);
            setSelectedTehlike('');
            setSelectedStand(null);
            setSelectedKonu('');
            setSelectedFaaliyet('');
            toggle();
        } catch (error) {
            console.error('Form submission error:', error);
            alert(t("uygunsuzlukModal.hataFormuKaydederkenBirSorun"));
        } finally {
            setLoading(false);
        }
    };

    const openFilePicker = (useCamera) => {
        // Native input elementi oluşturuyoruz — Reactstrap ref sorunundan kaçınmak için
        const input = document.createElement('input');
        input.type = 'file';
        input.accept = 'image/*';
        if (useCamera) {
            input.setAttribute('capture', 'environment');
        }
        input.onchange = (e) => {
            if (e.target.files && e.target.files[0]) {
                const file = e.target.files[0];
                setPhoto(file);
                setPhotoPreview(URL.createObjectURL(file));
            }
        };
        input.click();
    };

    return (
        <Modal isOpen={isOpen} toggle={toggle}>
            <ModalHeader toggle={toggle}>{t("uygunsuzlukModal.uygunsuzlukFormu")}</ModalHeader>
            <ModalBody>
                <Form onSubmit={handleSubmitU}>
                    {!selectedData && (
                        <FormGroup>
                            <Label>{t("uygunsuzlukModal.standSecimi")}</Label>
                            <AsyncSelect
                                cacheOptions
                                defaultOptions
                                loadOptions={loadStandOptions}
                                onChange={handleStandChange}
                                value={selectedStand}
                                placeholder={t("uygunsuzlukModal.standSeciniz")}
                            />
                        </FormGroup>
                    )}
                    {selectedData && (
                        <>
                            <FormGroup>
                                <Label>{t("uygunsuzlukModal.standAdi")}</Label>
                                <Input type="text" value={selectedData.stand_name || ''} disabled />
                            </FormGroup>
                            <FormGroup>
                                <Label>{t("uygunsuzlukModal.firmaAdi")}</Label>
                                <Input type="text" value={selectedData.name || ''} disabled />
                            </FormGroup>
                        </>
                    )}
                    <FormGroup>
                        <Label>{t("uygunsuzlukModal.konu")}</Label>
                        {konuName ? (
                            <Input type="text" value={konuName} disabled />
                        ) : (
                            <Input
                                type="select"
                                value={selectedKonu}
                                onChange={handleKonuChange}
                            >
                                <option value="">{t("uygunsuzlukModal.seciniz")}</option>
                                {konuOptions.map((option) => (
                                    <option key={option.id} data-code={option.category} value={option.id}>
                                        {option.name}
                                    </option>
                                ))}
                            </Input>
                        )}
                    </FormGroup>
                    <FormGroup>
                        <Label for="tehlikeSelect">{t("uygunsuzlukModal.tehlike")}</Label>
                        <Input
                            type="select"
                            name="tehlikeSelect"
                            id="tehlikeSelect"
                            value={selectedTehlike}
                            onChange={(e) => setSelectedTehlike(e.target.value)}
                        >
                            <option value="">{t("uygunsuzlukModal.seciniz")}</option>
                            {tehlikeOptions.map((option) => (
                                <option key={option.id} value={option.id}>
                                    {option.name}
                                </option>
                            ))}
                        </Input>
                    </FormGroup>
                    <FormGroup>
                        <Label>{t("uygunsuzlukModal.fotograf")}</Label>
                        <div className="d-flex gap-2">
                            <Button
                                type="button"
                                color="secondary"
                                onClick={() => openFilePicker(true)}
                                disabled={loading}
                            >
                                {t("uygunsuzlukModal.kamera")}
                            </Button>
                            <Button
                                type="button"
                                color="info"
                                onClick={() => openFilePicker(false)}
                                disabled={loading}
                            >
                                {t("uygunsuzlukModal.dosyaSec")}
                            </Button>
                            {photo && (
                                <Button
                                    type="button"
                                    color="danger"
                                    onClick={() => { setPhoto(null); setPhotoPreview(null); }}
                                    disabled={loading}
                                >
                                    {t("uygunsuzlukModal.kaldir")}
                                </Button>
                            )}
                        </div>
                        {photoPreview && (
                            <div className="mt-2">
                                <img
                                    src={photoPreview}
                                    alt={t("uygunsuzlukModal.onizleme")}
                                    style={{ maxWidth: '100%', maxHeight: '200px', borderRadius: '8px', objectFit: 'contain' }}
                                />
                                <div className="text-muted small mt-1">{photo.name}</div>
                            </div>
                        )}
                    </FormGroup>
                </Form>
            </ModalBody>
            <ModalFooter>
                <Button color="secondary" onClick={toggle} disabled={loading}>
                    {t("common:iptal")}
                </Button>
                <Button color="primary" onClick={handleSubmitU} disabled={loading}>
                    {loading ? t("uygunsuzlukModal.kaydediliyor") : t("common:kaydet")}
                </Button>
            </ModalFooter>
        </Modal>
    );
};

export default UygunsuzlukModal;
